module.exports = __webpack_public_path__ + "media/packs/facebook-53f28002b4f9b889d3368f4f314475f7.svg";